import { PillItem } from "@search/api/types";
import BaseFilter, {
  type BaseFilterType,
} from "@search/store/filters/base/BaseFilter";
import pluralize from "pluralize";

class NumberFilter extends BaseFilter {
  constructor({
    defaultValue,
    name = "number",
    label = name,
    value,
  }: BaseFilterType) {
    super({ defaultValue, label, name, value: value as number });
  }

  get defaultValue() {
    return super.defaultValue as number;
  }

  get initialValue() {
    return super.initialValue as number;
  }

  get value() {
    return super.value as number;
  }

  isSet() {
    return !!this.value && this.value !== this.defaultValue;
  }

  toPills(): Array<PillItem> {
    const pills: Array<PillItem> = [];
    const { value } = this;

    if (value > 0) {
      pills.push({
        key: pluralize(this.label, value, true),
        name: this.name,
      });
    }

    return pills;
  }
}

export default NumberFilter;
export { NumberFilter };
